/* CHANGELOG 2026-11-04. Dave via Perplexity Computer.
   Meteor mobile menu height sync. Meteor measures each sub-level once, before its lazy images load,
   which can clip cards and scroll the level header out of view. This keeps the container height equal to the
   visible level's real height and resets stray focus scroll. Read-only on menu content; no links or items changed.
   Rollback: remove this asset include from layout/theme.liquid. */
(function () {
  var nav = null, queued = false;
  function activeDrawer() {
    var ds = nav.querySelectorAll('.Meteor-Drawer[data-active="true"]');
    for (var i = ds.length - 1; i >= 0; i--) {
      if (ds[i].getAttribute('data-child-active') !== 'true') return ds[i];
    }
    return ds.length ? ds[ds.length - 1] : null;
  }
  function sync() {
    queued = false;
    if (!nav || !nav.isConnected) {
      var n = document.getElementById('meteor-mobile-nav');
      if (n && n !== nav) attach(n);
      return;
    }
    if (nav.scrollTop) nav.scrollTop = 0;
    if (nav.getAttribute('data-item-active') !== 'true') return;
    var d = activeDrawer();
    if (!d) return;
    var h = d.scrollHeight;
    var cur = parseFloat(nav.style.height) || 0;
    if (h > 0 && Math.abs(cur - h) > 1) nav.style.height = h + 'px';
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  function attach(n) {
    nav = n;
    new MutationObserver(queue).observe(nav, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-active', 'data-child-active', 'data-item-active', 'src', 'style'] });
    nav.addEventListener('load', queue, true);
    nav.addEventListener('scroll', queue);
    nav.addEventListener('transitionend', queue, true);
    window.addEventListener('resize', queue);
    queue();
  }
  function find() {
    var n = document.getElementById('meteor-mobile-nav');
    if (n) { attach(n); return true; }
    return false;
  }
  if (!find()) {
    var boot = new MutationObserver(function () { if (find()) boot.disconnect(); });
    boot.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
